import isAllowedHost from './isAllowedHost'
import isProductionEnv from './isProductionEnv'

const getUrlExtension = (extension: string, CLIENT_ID: string): string => {
  const currentUrl = window.location.href

  if (isAllowedHost(currentUrl) && !isProductionEnv())
    return `/${extension}/${CLIENT_ID}/`

  return isAllowedHost(currentUrl)
    ? `/${extension}/`
    : `/${extension}/${CLIENT_ID}/`
}

export default getUrlExtension
